import {OnDestroy} from "@angular/core";
import {MonoTypeOperatorFunction, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

export interface Destroyable extends OnDestroy {
  destroyed$: Subject<any>;
}

export function takeUntilDestroyed<Type>(subject: Destroyable): MonoTypeOperatorFunction<Type> {
  return takeUntil(subject.destroyed$);
}

export function onDestructionOf<ComponentType extends Destroyable>(component: ComponentType): Subject<ComponentType> {
  return new Subject<ComponentType>();
}